import { AppNames } from '~/common/models/appNames.model';
import { RouteName } from '~/common/models/route.model';
import { findRoute } from '~/common/utils/route/route.utils';

// Apps where FleetSwitcher is visible
export const SUPPORTED_APP_NAMES = [AppNames.FLEET, AppNames.ORGANIZATIONS];

// Routes where FleetSwitcher is enabled
const ENABLED_ROUTES = [
  RouteName.ORGANIZATIONS_VEHICLES,
  RouteName.ORGANIZATIONS_HOME,
  RouteName.ORGANIZATIONS_VEHICLES_MAP,
  RouteName.ORGANIZATIONS_INSIGHTS,
  RouteName.CS_PLATFORM_DRIVERS_LIST,
  RouteName.CS_PLATFORM_PERIPHERALS_LIST,
  RouteName.ORGANIZATIONS_MAP_GEOFENCES,
  RouteName.ORGANIZATIONS_MAP_GEOFENCES_CREATE,
  RouteName.ORGANIZATIONS_MAP_GEOFENCES_DETAILS,
  RouteName.ORGANIZATIONS_MAP_GEOFENCES_EDIT,
  RouteName.ORGANIZATIONS_SAFETY,
  RouteName.ORGANIZATIONS_SAFETY_LEADERBOARD,
  RouteName.ORGANIZATIONS_SAFETY_EVENT_HISTORY,
  RouteName.ORGANIZATIONS_REPORTS,
  RouteName.GETTING_STARTED,
];

// Exclude Advisor-only paths only when search string is empty
// const ADVISOR_PATHS = [AppRoutePaths.ASSET_LIST, RouteName.ORGANIZATIONS_VEHICLES];
const ADVISOR_PATHS = [RouteName.ORGANIZATIONS_VEHICLES];

export const getFleetSwitcherSupportedRoutes = (
  hasOrgParam: boolean
): string[] => {
  return ENABLED_ROUTES.map((routeName) => findRoute(routeName)).reduce<
    string[]
  >((paths, route) => {
    if (hasOrgParam) {
      /*
       * FleetSwitcher should theoretically be able to support
       * any route with an organizationsId param, but separate logic
       * will need to ensure the param is used to fetch the org children
       */
      return paths.concat(route.path || []);
    }
    if (typeof route.path === 'string' && !ADVISOR_PATHS.includes(route.name)) {
      return paths.concat(route.path || []);
    }
    return paths;
  }, []);
};
